import { Pagination } from 'components/shared/Blotter/Pagination/Pagination';

import { connectPaginationComponent } from './Pagination.connect';

export const ConnectedPagination = connectPaginationComponent(Pagination);
